import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IReleaseNote } from '../types/release-note.interface';

@Injectable({ providedIn: 'root' })
export class ReleaseNotesService {
  private http = inject(HttpClient);

  getReleaseNotes(): Observable<IReleaseNote[]> {
    return this.http
      .get<IReleaseNote[]>('assets/data/release-notes.json')
      .pipe(map((notes) => this.sortByVersion(notes)));
  }

  getReleaseNoteByVersion(version: string): Observable<IReleaseNote | null> {
    return this.getReleaseNotes().pipe(
      map((notes) => notes.find((n) => n.version === version) ?? null)
    );
  }

  private sortByVersion(notes: IReleaseNote[]): IReleaseNote[] {
    return [...notes].sort((a, b) => {
      const aParts = a.version.split('.').map(Number);
      const bParts = b.version.split('.').map(Number);
      for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const diff = (bParts[i] ?? 0) - (aParts[i] ?? 0);
        if (diff !== 0) return diff;
      }
      return 0;
    });
  }
}
